(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initRail(rail) {
      if (rail.dataset.sgReady) return;

      var list = rail.querySelector('[data-sg-rail-list]');
      var prev = rail.querySelector('[data-sg-rail-prev]');
      var next = rail.querySelector('[data-sg-rail-next]');
      if (!list || !prev || !next) return;

      rail.dataset.sgReady = '1';

      function update() {
        var max = list.scrollWidth - list.clientWidth - 2;
        prev.hidden = list.scrollLeft <= 2;
        next.hidden = max <= 0 || list.scrollLeft >= max;
      }

      function move(direction) {
        list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      rail.addEventListener('sg:refresh', update);
      update();
    }

    function initShop(shop) {
      if (shop.dataset.sgReady) return;
      shop.dataset.sgReady = '1';

      var tabs = Array.prototype.slice.call(shop.querySelectorAll('[data-sg-tab]'));
      var panels = Array.prototype.slice.call(shop.querySelectorAll('[data-sg-panel]'));

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });

        panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
          if (i === index) {
            var rail = panel.querySelector('[data-sg-rail]');
            if (rail) rail.dispatchEvent(new Event('sg:refresh'));
          }
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var step = event.key === 'ArrowRight' ? 1 : -1;
          select((i + step + tabs.length) % tabs.length, true);
        });
      });
    }

    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-sg-rail]').forEach(initRail);
      scope.querySelectorAll('[data-sg-shop]').forEach(initShop);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
